export const MapIcon = () => {
  return (
    <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.50008 0.5C2.75883 0.5 0.541748 2.8475 0.541748 5.75C0.541748 9.6875 5.50008 15.5 5.50008 15.5C5.50008 15.5 10.4584 9.6875 10.4584 5.75C10.4584 2.8475 8.24133 0.5 5.50008 0.5ZM1.95841 5.75C1.95841 3.68 3.54508 2 5.50008 2C7.45508 2 9.04175 3.68 9.04175 5.75C9.04175 7.91 7.00175 11.1425 5.50008 13.16C4.02675 11.1575 1.95841 7.8875 1.95841 5.75Z" fill="#EFEFEF"/>
    <path d="M5.50008 7.625C6.47809 7.625 7.27091 6.78553 7.27091 5.75C7.27091 4.71447 6.47809 3.875 5.50008 3.875C4.52208 3.875 3.72925 4.71447 3.72925 5.75C3.72925 6.78553 4.52208 7.625 5.50008 7.625Z" fill="#EFEFEF"/>
    </svg>    
    
  )
}
